import { useState, useEffect } from 'react';

/**
 * Viewport-based mobile detection, matching the app's 1024px breakpoint
 * convention (the width at which the bottom nav shows and the sidebar hides).
 *
 * This is DISTINCT from useIsStandalone: the mobile home renders on any narrow
 * viewport (installed PWA or plain mobile browser), whereas .pwa-mode CSS
 * gating is about the installed standalone app specifically.
 */
const QUERY = '(max-width: 1024px)';

export function getIsMobile() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(QUERY).matches;
}

export default function useIsMobile() {
  const [mobile, setMobile] = useState(getIsMobile);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return mobile;
}
